export const skillsData = [
    'HTML',
    'CSS',
    'C#',
    'JavaScript',
    'TypeScript',
    'Python',
    'php',
    'Sublime Text',
    'Visual Studio Code',
    'Git',
    'GitHub',
    'Node JS',
    'npm',
    'Vite JS',
    'Bootstrap',
    'MaterialUI',
    'jQuery',
    'React',
    'Next JS',
    'Express JS',
    'Nest JS',
    'Django',
    'Docker',
    'SQLite',
    'MySQL',
    'PostgreSQL',
    'Unity',
    'WordPress',
    'Firebase',
    'AWS',
    'GCP',
    'Meta Ads',
    'TikTok Ads',
    'X Ads',
    'LinkedIn Ads'
]
